import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Store} from "@ngxs/store";
import {Observable} from "rxjs";
import {GetUserPortalActiveDiscount} from '../actions/discount.action';

@Injectable({ providedIn: 'root' })
export class UserDiscountResolver  {
    constructor(private store: Store) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.store.dispatch(new GetUserPortalActiveDiscount())
    }
}
